<template>
  <el-select ref="timeSelect" v-model="selectValue" @change="handleChange">
    <associateColumn />
  </el-select>
</template>
<script>
import associateColumn from './tabs.vue';
export default {
    comments:{
      associateColumn
    },
    props: {
        value: [String, Number],
        valueKey: {
            type: [String, Number]
            // required: true
        },
        labelKey: [String, Number]
    },
    components: {
        associateColumn
    },
    provide() {
        return {
            timeSelect: this
        };
    },
    data() {
        return {
            selectValue: ''
        };
    },
    watch: {
        value(val) {
            this.setValue(val);
        },
        selectValue(val) {
            this.$emit('input', val);
        }
    },
    created() {
        this.setValue(this.value);
    },
    methods: {
        setValue(val) {
            this.selectValue = val;
        },
        handleChange(val) {
            this.$emit('change', val);
        }
    }
};
</script>
